import { useEffect } from "react";
import { BasketItem } from "../../../models/BasketItem";
import { useDispatch, useSelector } from "react-redux";
import { updateCalendarSaleQntState } from "../../../store/basket/basketActions";
import { State } from "../../../store";

/* eslint-disable import/no-anonymous-default-export */
export default (preBasket: BasketItem[]) => {
  const dispatch = useDispatch();
  const qntState = useSelector((state: State) => state.basket.calendarSaleQntState);

  useEffect(() => {
    const grouped = preBasket.reduce((acc: any, item) => {
      const { assortIds, ticketAccess } = item;
      const exerciseIds =
        Array.isArray(ticketAccess) && ticketAccess.length > 0 ? ticketAccess[0].exerciseIds : undefined;
      const key = `${assortIds}-${exerciseIds}`;

      if (!acc[key]) {
        acc[key] = { assortIds, exerciseIds, count: item.qnt };
      } else {
        acc[key].count += item.qnt;
      }

      return acc;
    }, {});

    dispatch(
      updateCalendarSaleQntState(
        Object.values(grouped).map((item: any) => ({
          assortIds: item.assortIds,
          exerciseIds: item.exerciseIds,
          count: item.count,
        }))
      )
    );
    //eslint-disable-next-line
  }, [preBasket]);

  return { qntState };
};
